import { useToastContext } from "components/alert/ToastContext";
import InputMonetario from "components/input/InputMonetario";
import Produto from "model/administracao/cadastro/produto/Produto";
import AjusteEstoque from "model/suprimentos/AjusteEstoque";
import Deposito from "model/suprimentos/Deposito";
import EstoqueLote from "model/suprimentos/EstoqueLote";
import Transacao from "model/suprimentos/Transacao";
import { AutoComplete } from "primereact/autocomplete";
import { Badge } from "primereact/badge";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Tooltip } from "primereact/tooltip";
import { useEffect, useRef, useState } from "react";
import ContaParametroService from "service/administracao/cadastro/ContaParametroService";
import AjusteEstoqueService from "service/suprimentos/AjusteEstoqueService";
import { produtoCompleteMethod, produtoItemTemplate } from "utils/autocompleteUtils";


type Props = {

}

const ajusteEstoqueService = new AjusteEstoqueService();
const contaParametroService = new ContaParametroService();
export default function AjusteEstoqueCadastro(props: Props) {

    const { msgAlerta, msgErro, msgSucesso } = useToastContext();

    const [ajusteEstoque, setAjusteEstoque] = useState<AjusteEstoque>(new AjusteEstoque());

    const [ajustado, setAjustado] = useState<boolean>(false);

    const [transacoesDisponiveis, setTransacoesDisponiveis] = useState<Transacao[]>([]);
    const [depositos, setDepositos] = useState<Deposito[]>([]);

    const [produtosDisponives, setProdutosDisponives] = useState<Produto[]>([]);
    const [produtosFiltrados, setProdutosFiltrados] = useState<Produto[]>([]);
    const [lotesDisponiveis, setLotesDisponiveis] = useState<EstoqueLote[]>([]);

    const depositoOrigemRef = useRef<any>(null);

    const [temIntegracao, setTemIntegracao] = useState<boolean>(false);

    useEffect(() => {
        ajusteEstoqueService.getDepositos().then((data) => {
            setDepositos(data);
        }).catch((error) => {
            console.log(error);
        });

        contaParametroService.buscarParametro('URL_DATABASE_YOUPRATICO').then((data) => {
            setTemIntegracao(data as unknown as boolean);
        }).catch((error) => {
            console.log(error);
        })
    }, [])

    useEffect(() => {
        if (ajusteEstoque.tipo) {
            ajusteEstoqueService.getTransacaoPadrao(ajusteEstoque.tipo).then((data) => {
                setAjusteEstoque({ ...ajusteEstoque, transacao: data });
            }).catch((error) => {
                console.log(error);
            });
        }
    }, [ajusteEstoque.tipo])

    useEffect(() => {
        if (ajusteEstoque.deposito && ajusteEstoque.deposito.codigo && ajusteEstoque.tipo) {
            if (ajusteEstoque.tipo === "ENTRADA") {
                ajusteEstoqueService.getTodosProdutos().then((data) => {
                    setProdutosDisponives(data);
                }).catch((error) => {
                    console.log(error);
                });
            } else if (ajusteEstoque.tipo === "SAIDA") {
                ajusteEstoqueService.getProdutosDisponiveis(ajusteEstoque.deposito).then((data) => {
                    setProdutosDisponives(data);
                }).catch((error) => {
                    console.log(error);
                });
            }

        }
    }, [ajusteEstoque.deposito, ajusteEstoque.tipo])

    useEffect(() => {
        if (ajusteEstoque.tipo) {
            ajusteEstoqueService.getTransacoes(ajusteEstoque.tipo).then((data) => {
                setTransacoesDisponiveis(data)
            }).catch((error) => {
                console.log(error);
            });
        }

    }, [ajusteEstoque.tipo])

    function getLotesDisponiveis(deposito: Deposito, produto: Produto) {
        ajusteEstoqueService.getLotesDisponiveis(deposito, produto).then((data) => {
            setLotesDisponiveis(data);
        }).catch((error) => {
            console.log(error);
        });
    }

    function ajustar() {
        if (!podeAjustar()) {
            return;
        }
        if (ajusteEstoque.tipo === "ENTRADA") {
            ajusteEstoque.lote.produto = ajusteEstoque.produto;
            ajusteEstoque.lote.deposito = ajusteEstoque.deposito;
        }
        ajusteEstoqueService.ajustar(ajusteEstoque).then(() => {
            msgSucesso("Ajuste de estoque", "Ajuste realizado com sucesso");
            setAjustado(true);
        }).catch((error) => {
            console.log(error)
            msgAlerta("Ajuste de estoque", error.data.message);
        });
    }

    function podeAjustar() {
        if (ajusteEstoque.tipo === null || ajusteEstoque.tipo === '') {
            msgAlerta("Tipo", "Informe o tipo");
            return false;
        }

        if (ajusteEstoque.transacao === null || ajusteEstoque.transacao.codigo === null) {
            msgAlerta("Transação", "Informe a transação");
            return false;
        }
        if (ajusteEstoque.deposito === null || ajusteEstoque.deposito.codigo === null) {
            msgAlerta("Depósito", "Informe o depósito");
            return false;
        }
        if (ajusteEstoque.produto == null || !ajusteEstoque.produto.codigo) {
            msgAlerta("Produto", "Informe o produto");
            return false;
        }

        if (!ajusteEstoque.lote || !ajusteEstoque.lote.lote) {
            msgAlerta("Lote", "Informe o lote");
            return false;
        }

        if (ajusteEstoque.quantidade == 0) {
            msgAlerta("Quantidade", "Informe a quantidade");
            return false;
        }

        return true;
    }

    return (

        <div className="container">

            {temIntegracao ? <div style={{ display: "flex", marginTop: 12, alignItems: "center" }}>
                <Checkbox style={{ marginRight: 8 }} checked={ajusteEstoque.integrado} onChange={(e) => setAjusteEstoque({ ...ajusteEstoque, integrado: e.checked as boolean })} />
                <label style={{ marginRight: 8 }}>Integrado</label>

                <Tooltip target=".custom-target-icon" position="top" />
                <Badge value="!" className="custom-target-icon" severity="info" data-pr-tooltip="Caso marque esse check, o movimento de estoque não será integrado no You Prático"></Badge>

            </div> : null}

            <div className="row">
                <label className="col col-sm-12">Tipo</label>
                <div className="col-sm-12">
                    <Dropdown
                        disabled={ajustado} value={ajusteEstoque.tipo} options={ajusteEstoqueService.getTiposTransacao()}
                        optionLabel="label" optionValue="value" placeholder="Selecione o tipo de ajuste"
                        onChange={(e) => setAjusteEstoque({ ...ajusteEstoque, tipo: e.value, transacao: new Transacao(), produto: new Produto(), lote: new EstoqueLote() })} style={{ width: '30%' }}
                    />
                </div>
            </div>


            <div className="row">
                <label className="col col-sm-12">Transação</label>
                <div className="col-sm-12">
                    <Dropdown disabled={ajustado} value={ajusteEstoque.transacao}
                        options={transacoesDisponiveis} optionLabel="descricao" placeholder="Selecione a transação"
                        onChange={(e) => setAjusteEstoque({ ...ajusteEstoque, transacao: e.value })} style={{ width: '30%' }}
                    />
                </div>
            </div>

            <div className="row">
                <label className="col col-sm-12">Depósito</label>
                <div className="col-sm-12">
                    <Dropdown
                        placeholder="Selecione o depósito"
                        disabled={ajustado}
                        ref={depositoOrigemRef}
                        value={ajusteEstoque.deposito}
                        options={depositos} optionLabel="nome"
                        onChange={(e) => setAjusteEstoque({ ...ajusteEstoque, deposito: e.value, produto: new Produto(), lote: new EstoqueLote() })}
                        style={{ width: '30%' }}
                    />
                </div>
            </div>

            <div className="row">
                <label className="col col-sm-12">Produto</label>
                <div className="col-sm-12">
                    <AutoComplete
                        placeholder="Selecione o produto" disabled={ajustado} value={ajusteEstoque.produto}
                        suggestions={produtosFiltrados} field="nome"
                        itemTemplate={(item: Produto) => produtoItemTemplate(item)}
                        completeMethod={(e) => {
                            let filtered = produtoCompleteMethod(produtosDisponives, e.query);
                            setProdutosFiltrados(filtered);
                        }}
                        onChange={(e) => {
                            if (typeof e.target.value == "string") {
                                let prod = new Produto();
                                prod.nome = e.target.value;
                                ajusteEstoque.produto = prod;
                                ajusteEstoque.lote = new EstoqueLote();
                            } else {
                                ajusteEstoque.produto = e.target.value;
                                getLotesDisponiveis(ajusteEstoque.deposito, e.target.value);

                            }
                            setAjusteEstoque({ ...ajusteEstoque })
                        }}
                        onFocus={(e) => {
                            if (ajusteEstoque.deposito == null || ajusteEstoque.deposito.codigo == null) {
                                if (depositoOrigemRef.current) {
                                    depositoOrigemRef.current.focus();
                                    e.preventDefault();
                                }
                            }
                        }}
                        inputStyle={{ width: '100%' }}
                        style={{ width: '30%' }}
                    />
                </div>
            </div>
            {ajusteEstoque.tipo === "SAIDA" &&
                <div className="row">
                    <label className="col col-sm-12">Lote</label>
                    <div className="col-sm-12">
                        <Dropdown disabled={ajustado} placeholder="Selecione o lote para Saída" value={ajusteEstoque.lote} options={lotesDisponiveis} optionLabel="lote"
                            onChange={(e) => {
                                ajusteEstoque.lote = e.value;

                                ajusteEstoqueService.getValorUnitario(e.value).then((data) => {
                                    ajusteEstoque.valorUnitario = data;
                                    setAjusteEstoque({ ...ajusteEstoque });
                                }).catch((error) => {
                                    console.log(error);
                                });
                            }}
                            style={{ width: '30%' }}
                        />

                    </div>
                </div>
            }

            {ajusteEstoque.tipo === "ENTRADA" &&
                <>
                    <div className="row">
                        <label className="col col-sm-12">Lote</label>
                        <div className="col-sm-12">
                            <InputText disabled={ajustado} maxLength={50} placeholder="Digite o lote de entrada" style={{ width: '30%' }} value={ajusteEstoque.lote.lote ? ajusteEstoque.lote.lote : ""} onChange={(e) => {
                                ajusteEstoque.lote.lote = e.target.value;
                                setAjusteEstoque({ ...ajusteEstoque })
                            }} />

                        </div>
                    </div>

                    <div className="row">
                        <label className="col col-sm-12">Validade</label>
                        <div className="col-sm-12">
                            <Calendar locale="pt-BR" dateFormat="dd/mm/yy" value={ajusteEstoque.lote.validade} onChange={(e) => {
                                if (e.value instanceof Date) {
                                    ajusteEstoque.lote.validade = e.value;
                                    setAjusteEstoque({ ...ajusteEstoque })
                                }
                            }} style={{ width: '30%' }} />

                        </div>
                    </div>



                </>
            }

            <div className="row">
                <label className="col col-sm-12">Quantidade</label>
                <div className="col-sm-12">
                    <InputNumber disabled={ajustado} value={ajusteEstoque.quantidade} useGrouping={false}
                        onFocus={(e) => e.target.select()}
                        locale="pt-BR"
                        minFractionDigits={1} maxFractionDigits={5} maxLength={10}
                        onChange={(e) => {
                            ajusteEstoque.quantidade = e.value;
                            setAjusteEstoque({ ...ajusteEstoque })
                        }}
                        style={{ width: '30%' }}
                    />
                </div>
            </div>

            <div className="row">
                <label className="col col-sm-12">Valor Unitário</label>
                <div className="col-sm-12" style={{ width: '30%' }}>
                    <InputMonetario disabled={ajustado} value={ajusteEstoque.valorUnitario || 0}
                        onChange={(e) => {
                            ajusteEstoque.valorUnitario = e;
                            setAjusteEstoque({ ...ajusteEstoque })
                        }}

                    />
                </div>
            </div>

            <div className="row">
                <label className="col col-sm-12">Observação</label>
                <div className="col-sm-12" style={{ width: '73%' }}>
                    <InputTextarea
                        required value={ajusteEstoque.observacao || ''}
                        style={{ width: '50%' }}
                        rows={4}
                        onChange={(e) => {
                            setAjusteEstoque({ ...ajusteEstoque, observacao: e.target.value })
                        }}
                    />
                </div>
            </div>

            <div className="row" style={{ marginTop: 20 }}>
                <div className="col col-sm-12">

                    <Button disabled={ajustado} label="Ajustar" onClick={() => {
                        ajustar();
                    }}></Button>
                    {ajustado && <Button label="Novo Ajuste" style={{ marginLeft: 10 }} onClick={() => {
                        setAjusteEstoque(new AjusteEstoque());
                        setAjustado(false);
                    }} ></Button>}
                </div>
            </div>



        </div>


    )

}